import React from 'react';
import Icon from '../../../components/AppIcon';

const WorkoutStreakCard = ({ 
  currentStreak, 
  longestStreak, 
  weeklyGoal = 5,
  thisWeekWorkouts = 3
}) => {
  const weekProgress = (thisWeekWorkouts / weeklyGoal) * 100;

  return (
    <div className="bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20 rounded-lg p-4 md:p-6 shadow-md">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent text-accent-foreground">
          <Icon name="Flame" size={24} strokeWidth={2.5} />
        </div>
        <div>
          <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">
            Workout Streak
          </h3>
          <p className="text-xs md:text-sm caption text-muted-foreground">
            Keep the momentum going!
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="bg-card rounded-lg p-3 md:p-4">
          <p className="text-xs md:text-sm caption text-muted-foreground mb-1">
            Current Streak
          </p>
          <div className="flex items-baseline gap-1">
            <span className="text-2xl md:text-3xl font-heading font-bold text-accent data-text">
              {currentStreak}
            </span>
            <span className="text-sm text-muted-foreground">days</span>
          </div>
        </div>

        <div className="bg-card rounded-lg p-3 md:p-4">
          <p className="text-xs md:text-sm caption text-muted-foreground mb-1">
            Best Streak
          </p>
          <div className="flex items-baseline gap-1">
            <span className="text-2xl md:text-3xl font-heading font-bold text-foreground data-text">
              {longestStreak}
            </span>
            <span className="text-sm text-muted-foreground">days</span>
          </div>
        </div>
      </div>

      <div>
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm md:text-base font-medium text-foreground">
            This Week's Progress
          </p>
          <span className="text-xs md:text-sm font-semibold text-accent data-text">
            {thisWeekWorkouts}/{weeklyGoal} workouts
          </span>
        </div>
        <div className="relative h-3 bg-muted rounded-full overflow-hidden">
          <div 
            className="absolute top-0 left-0 h-full bg-accent rounded-full transition-smooth"
            style={{ width: `${Math.min(weekProgress, 100)}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default WorkoutStreakCard;